import { render, staticRenderFns } from "./AnnouncementAppView.vue?vue&type=template&id=28c9c42f"
import script from "./AnnouncementAppView.vue?vue&type=script&lang=js"
export * from "./AnnouncementAppView.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementAppView.vue?vue&type=style&index=0&id=28c9c42f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports